import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a TruckWash icon.
 *
 * @function
 * @param {Object} [props] - The component properties
 * @returns {JSX.Element} React component markup
 *
 * @see SvgIcon
 * @example
 * <TruckWashIcon width={24} />
 */
const TruckWashIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M19.2 17.4V22.2C19.2 22.41 19.12 22.62 18.97 22.77C18.82 22.92 18.61 23 18.4
            23H16.8C16.59 23 16.38 22.92 16.23 22.77C16.08 22.62 16 22.41 16 22.2V21.4H7.99999V22.2C7.99999
            22.41 7.91999 22.62 7.76999 22.77C7.61999 22.92 7.40999 23 7.19999 23H5.59999C5.38999 23 5.17999
            22.92 5.02999 22.77C4.87999 22.62 4.79999 22.41 4.79999 22.2V17.4C4.79999 16.98 4.96999 16.57
            5.26999 16.27C5.56999 15.97 5.97999 15.8 6.39999 15.8V14.2C6.18999 14.2 5.97999 14.12 5.82999
            13.97C5.67999 13.82 5.59999 13.61 5.59999 13.4V11.8C5.59999 11.59 5.67999 11.38 5.82999 11.23C5.97999
            11.08 6.18999 11 6.39999 11V7.8C6.39999 7.59 6.47999 7.38 6.62999 7.23C6.77999 7.08 6.98999 7 7.19999
            7H16.8C17.01 7 17.22 7.08 17.37 7.23C17.52 7.38 17.6 7.58 17.6 7.8V11C17.81 11 18.02 11.08 18.17
            11.23C18.32 11.38 18.4 11.58 18.4 11.8V13.4C18.4 13.61 18.32 13.82 18.17 13.97C18.02 14.12 17.82 14.2
            17.6 14.2V15.8C18.02 15.8 18.43 15.97 18.73 16.27C19.03 16.57 19.2 16.98 19.2 17.4ZM16.4 11.8C16.4
            11.59 16.32 11.38 16.17 11.23C16.02 11.08 15.81 11 15.6 11H8.39999C8.18999 11 7.97999 11.08 7.82999
            11.23C7.67999 11.38 7.59999 11.59 7.59999 11.8V14.2C7.59999 14.41 7.67999 14.62 7.82999 14.77C7.97999
            14.92 8.18999 15 8.39999 15H15.6C15.81 15 16.02 14.92 16.17 14.77C16.32 14.62 16.4 14.42 16.4
            14.2V11.8ZM15.2 17.4C15.2 17.19 15.12 16.98 14.97 16.83C14.82 16.68 14.62 16.6 14.4
            16.6H9.59999C9.38999 16.6 9.17999 16.68 9.02999 16.83C8.87999 16.98 8.79999 17.19 8.79999
            17.4V19.8C8.79999 20.01 8.87999 20.22 9.02999 20.37C9.17999 20.52 9.37999 20.6 9.59999
            20.6H14.4C14.61 20.6 14.82 20.52 14.97 20.37C15.12 20.22 15.2 20.02 15.2 19.8V17.4ZM17.2 16.8C17
            16.8 16.81 16.86 16.64 16.97C16.48 17.08 16.35 17.24 16.27 17.42C16.19 17.6 16.17 17.8 16.21
            18C16.25 18.19 16.34 18.37 16.48 18.51C16.62 18.65 16.8 18.75 16.99 18.78C17.18 18.82 17.39 18.8
            17.57 18.72C17.75 18.64 17.91 18.52 18.02 18.35C18.13 18.19 18.19 17.99 18.19 17.79C18.19 17.52
            18.08 17.27 17.9 17.08C17.72 16.91 17.47 16.8 17.2 16.8ZM6.79999 16.8C6.59999 16.8 6.40999 16.86
            6.23999 16.97C6.07999 17.08 5.94999 17.24 5.86999 17.42C5.79999 17.6 5.77999 17.8 5.81999 18C5.85999
            18.19 5.94999 18.37 6.08999 18.51C6.22999 18.65 6.40999 18.75 6.59999 18.78C6.79999 18.82 6.99999
            18.8 7.17999 18.72C7.35999 18.64 7.51999 18.52 7.62999 18.35C7.73999 18.19 7.79999 18 7.79999
            17.8C7.79999 17.53 7.68999 17.28 7.50999 17.09C7.31999 16.91 7.06999 16.8 6.79999 16.8ZM13.06
            4.56C13.35 4.27 13.5 3.91 13.5 3.5C13.5 3.15 13.38 2.78 13.14 2.38C12.9 1.98 12.52 1.52 12 1C11.48
            1.52 11.1 1.98 10.86 2.38C10.62 2.78 10.5 3.15 10.5 3.5C10.5 3.92 10.65 4.27 10.94 4.56C11.23 4.85
            11.58 5 12 5C12.42 5 12.77 4.85 13.06 4.56ZM8.05999 4.56C8.34999 4.27 8.49999 3.92 8.49999
            3.5C8.49999 3.15 8.37999 2.78 8.13999 2.38C7.89999 1.98 7.51999 1.52 6.99999 1C6.47999 1.52 6.09999
            1.98 5.85999 2.38C5.61999 2.78 5.49999 3.15 5.49999 3.5C5.49999 3.92 5.64999 4.27 5.93999
            4.56C6.22999 4.85 6.57999 5 6.99999 5C7.41999 5 7.76999 4.85 8.05999 4.56ZM18.06 4.56C18.35 4.27
            18.5 3.91 18.5 3.5C18.5 3.15 18.38 2.78 18.14 2.38C17.9 1.98 17.52 1.52 17 1C16.48 1.52 16.1 1.98
            15.86 2.38C15.62 2.78 15.5 3.15 15.5 3.5C15.5 3.92 15.65 4.27 15.94 4.56C16.23 4.85 16.58 5 17
            5C17.42 5 17.77 4.85 18.06 4.56Z`}
        />
    </SvgIcon>
)

TruckWashIcon.defaultProps = defaultProps

export { TruckWashIcon }
